<div class="main-404">
  <img [src]="imgPath" />
  <div class="title">Ooops...</div>
  <div class="description">
    {{ "not-found-route.description" | translate }}
  </div>
  <a [routerLink]="homeUrl" class="redirect">
    {{ "not-found-route.go-back" | translate }}
    {{ "dashboard.title" | translate }}
  </a>
</div>
